import React from 'react';
import AdressComponnent from '../../../elements/AdressComponnent';
import { translateAdressApiToModelExtern } from '../../Checkout_VR';
import { getObjectFromForm, injectPhpDebug } from '../../../../../mol_function';
import $ from 'jquery';

interface AddressEditProp {
  data: any;
  apiBase: string;
  userID: number;
}

interface AddressEditState {
  isBillingAddress: boolean;
  isShippingAddress: boolean;
  shipmentDays: string[];
}

export default class AddressEdit extends React.Component<
  AddressEditProp,
  AddressEditState
> {
  constructor(props: AddressEditProp) {
    super(props);

    const addr = props.data.addresse[0];
    this.state = {
      isBillingAddress: addr.isBillingAddress,
      isShippingAddress: addr.isShippingAddress,
      shipmentDays: addr.sammlung_shipmentdays
        ? addr.sammlung_shipmentdays.split(',')
        : [],
    };
  }

  render(): React.ReactNode {
    const addr = this.props.data.addresse[0];

    return (
      <form
        onSubmit={(event1) => {
          event1.preventDefault();

          let result: any = getObjectFromForm($(event1.target));

          result['isBillingAddress'] = this.state.isBillingAddress
            ? 'on'
            : 'off';
          result['isShippingAddress'] = this.state.isShippingAddress
            ? 'on'
            : 'off';
          result['sammlung_shipmentdays'] = this.state.shipmentDays.join(',');
          [
            'shipping_mon',
            'shipping_tue',
            'shipping_wed',
            'shipping_thu',
            'shipping_fri',
          ].forEach((k) => delete result[k]);

          let command = 'updateAddresse';

          if (result.adress_id == null) {
            command = 'insertAddresse';
            result.user_id = this.props.userID;
          }

          let oneCommandItem = {
            command: command,
            commandParams: null,
          };

          let url = injectPhpDebug(
            this.props.apiBase +
              '/Account.php?oneCommand=' +
              encodeURIComponent(JSON.stringify(oneCommandItem)),
          );

          fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(result),
          })
            .then((res) => res.json())
            .then(
              (result) => {
                window.historyHelper.memory.push('/konto/address', null);
              },
              (error) => {},
            );
        }}
      >
        <AdressComponnent
          {...translateAdressApiToModelExtern(
            addr,
            this.props.data.countrys,
            false,
          )}
        />
        <input
          type={'checkbox'}
          name="isBillingAddress"
          checked={this.state.isBillingAddress}
          onChange={(e) =>
            this.setState({ isBillingAddress: e.target.checked })
          }
        />
        Rechnungsadresse
        <br />
        {this.state.isBillingAddress && (
          <div style={{ marginLeft: '20px' }}>
            <input
              type={'checkbox'}
              name="default_Billing"
              defaultChecked={addr.isBillingDefault}
            />
            Standard Rechnungsadresse
            <br />
          </div>
        )}
        <input
          type={'checkbox'}
          name="isShippingAddress"
          checked={this.state.isShippingAddress}
          onChange={(e) =>
            this.setState({ isShippingAddress: e.target.checked })
          }
        />
        <input
          type={'hidden'}
          name="versand_einstellung_id"
          value={addr.versand_einstellung_id}
        />
        Versandadresse
        <br />
        {this.state.isShippingAddress && (
          <div style={{ marginLeft: '20px' }}>
            <input
              type={'checkbox'}
              name="default_Shipping"
              defaultChecked={addr.isShippingDefault}
            />
            Standard Versandadresse
            <br />
            Versandtage:
            <br />
            <div style={{ display: 'flex', gap: '12px', marginTop: '4px' }}>
              {[
                { name: 'shipping_mon', label: 'Mo', index: '0' },
                { name: 'shipping_tue', label: 'Di', index: '1' },
                { name: 'shipping_wed', label: 'Mi', index: '2' },
                { name: 'shipping_thu', label: 'Do', index: '3' },
                { name: 'shipping_fri', label: 'Fr', index: '4' },
              ].map((day) => (
                <label
                  key={day.name}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '2px',
                  }}
                >
                  {day.label}
                  <input
                    type={'checkbox'}
                    name={day.name}
                    checked={this.state.shipmentDays.includes(day.index)}
                    onChange={(e) => {
                      const days = e.target.checked
                        ? [...this.state.shipmentDays, day.index]
                        : this.state.shipmentDays.filter(
                            (d) => d !== day.index,
                          );
                      this.setState({ shipmentDays: days });
                    }}
                  />
                </label>
              ))}
            </div>
          </div>
        )}
        <input type={'submit'} />
      </form>
    );
  }
}
